import { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

import { imgV1 } from '@styles/utils';

import '@v1/styles/pages/marketing/_our_story.scss';

export default function OurStoryPage() {
    const videoRef = useRef();
    const [isLink, setIsLink] = useState(true);


    const playPause = () => {
        if (!videoRef || !videoRef.current) {
            return setIsLink(false);
        }

        if ((videoRef.current as any).paused) {
            (videoRef.current as any).play();
        } else {
            (videoRef.current as any).pause();
        }
    }

    return (
        <div className="b-our-story">
            <section className="e-top-video-section">
                <div className="e-video-outer-wrap">
                    <div className="e-player-wrap">
                    {isLink ?
                        <a onClick={playPause}>
                            <img loading="lazy"
                                className="e-img"
                                src={imgV1('/our_story/video.jpg')}
                                alt="Play video" />
                        </a> :
                        <video ref={videoRef}
                            autoPlay
                            className="e-video"
                            onClick={playPause}
                            onEnded={() => setIsLink(true)}>
                            <source
                                type="video/mp4"
                                src="https://content.jwplatform.com/videos/4Q76Lap0-Cx61c2kK.mp4" />
                        </video>
                    }
                    </div>
                </div>
            </section>
            <section className="e-story">
                <h1 className="e-title">Our Story</h1>
                <p className="e-text">
                    Our founder has always been in love with the brain. Already a practicing neurosurgeon, she was inspired
                    to go back to school and learn more about how the human brain grows, earning a PhD in Developmental
                    Neurobiology at&nbsp;Stanford.
                </p>
                <p className="e-text">
                    Her mission to find a better treatment for pediatric brain cancer turned into a fascination with understanding
                    the myriad of factors that go into optimal brain development.
                </p>
                <p className="e-text">
                    Becoming a mom at the same time led her to look at her work through a different lens: not only what switches occurred when brain development went wrong,
                    but now also what events have to go right to support optimal brain development.
                </p>
                <img loading="lazy" className="e-babies" src={imgV1('/our_story/aside.jpg')} alt="Baby face" />
                <blockquote className="e-quote">
                    She quickly came to realize that early life nutrition was a critical factor needed to best support the developmental changes rapidly occurring before her.
                </blockquote>
                <p className="e-text">
                    A baby’s brain doubles in size by its first year and reaches nearly 80% of development by the age of 5.
                    This critical age window is when the most developmental foundations are forming in the brain, such as seeing, hearing, and memory.
                </p>
                <p className="e-text">
                    As a clinical scientist, she has always felt a responsibility towards knowledge mobilization and scientific translation.
                    Just as her work in drug development and medical devices were essential tools to bring science into the fight against pediatric brain cancers,
                    she was similarly convinced that if she could get the nutrients that matter into what we feed our little ones,
                    it would make a lifelong difference for children everywhere.
                </p>
                <p className="e-text">
                    As a neurobiologist, she knew there were key nutrients that were critical for each of those milestones,
                    and as a mom, she needed the convenience of premade food. After many trips down the baby food aisle,
                    she could not find one brand that met even the most basic quality and nutrient requirements needed for optimal development.
                    Her research showed that 16 essential nutrients were critical for optimal brain development,
                    yet the average baby puree only had only a fraction and not even in meaningful amounts.
                </p>
                <p className="e-text">
                    After years of development with a team of scientists, doctors, and nutritionists,
                    Cerebelly was created as a natural extension to our founder’s work — a first-of-its-kind food brand that satisfies parents,
                    kids & growing brains alike. What you’re feeding your child isn’t just a tasty treat, it’s years of trailblazing well beyond
                    industry norms to provide 16 key brain-supporting nutrients needed for early development.
                    Meticulously sourced, organic vegetable-first formulas with no added sugar,
                    that undergo rigorous testing for heavy metals and harmful toxins every step of the way.
                </p>
            </section>
            <section className="e-nourish">
                <div className="e-inner">
                    <p className="e-text">We believe there is a better&nbsp;way&nbsp;to</p>
                    <img loading="lazy" className="e-super" src={imgV1('/our_story/nourish_our_kids.svg')} alt="Nourish Our Kids" />
                    <p className="e-text">
                        Cerebelly unites neuroscience, nutrition, and organic, farm-fresh food to give them the very best from
                        the&nbsp;very&nbsp;start.
                    </p>
                </div>
            </section>
            <section className="e-our-values">
                <div className="e-value-wrap m-good-facts">
                    <img loading="lazy" alt="" className="e-value-img" src={imgV1('/our_story/good_facts.jpg')} />
                    <div className="e-value-text-wrap">
                        <div className="e-text-inner-wrap">
                            <h2 className="e-value-header">Good Facts</h2>
                            <p className="e-text">
                                As a science-first company, we always look to available facts, data, and research to make our decisions.
                            </p>
                            <p className="e-text">
                                <Link className="e-value-link" to="/science/">Real Science</Link>
                            </p>
                        </div>
                    </div>
                </div>

                <img loading="lazy" alt="" className="e-overlay-apple" src={imgV1('/our_story/apple.svg')} />

                <div className="e-value-wrap m-good-food">
                    <div className="e-value-text-wrap">
                        <div className="e-text-inner-wrap">
                            <h2 className="e-value-header">Good Food</h2>
                            <p className="e-text">We always go above and beyond when it comes to the quality of our products and the sourcing of our ingredients.</p>
                            <p className="e-text">
                                <Link className="e-value-link" to="/parenting-is-an-art/">Smart Food</Link>
                            </p>
                        </div>
                    </div>
                    <img loading="lazy" alt="" className="e-value-img" src={imgV1('/our_story/good_food.jpg')} />
                </div>

                <img loading="lazy" alt="" className="e-overlay-berries" src={imgV1('/our_story/berries.svg')} />

                <div className="e-value-wrap m-good-works">
                    <div className="e-value-text-wrap">
                        <div className="e-text-inner-wrap">
                            <h2 className="e-value-header">Good Works</h2>
                            <p className="e-text">
                                We are committed to fighting for the health and well-being of all children.
                            </p>
                            <p className="e-text">
                                <Link className="e-value-link" to="/baby2baby/">Baby2Baby</Link>
                            </p>
                        </div>
                    </div>
                    <img loading="lazy" alt="" className="e-value-img" src={imgV1('/our_story/good_works.jpg')} />
                    <div className="e-img-wrap"></div>
                </div>

                <img loading="lazy" alt="" className="e-overlay-leaf" src={imgV1('/our_story/leaf.svg')} />
            </section>
        </div>
    );
}
